import {BaseWrapper} from '../../framework/parameters/BaseWrapper';
import {EntityModification} from '../message/EntityModification';
import {EntityModificationCriteria} from './EntityModificationCriteria';
import {EntityModificationScenario} from './EntityModificationScenario';
import {EntityModificationTrace} from './EntityModificationTrace';

export class EntityModificationWrapper extends BaseWrapper<EntityModification, EntityModificationCriteria, EntityModificationScenario>  {
_deletionList: EntityModificationTrace[];
}

